"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[LaunchLemonade global error]", error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#0a0f1a",
          color: "#FFFDE7",
          fontFamily:
            "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
          padding: "2rem",
          textAlign: "center",
        }}
      >
        <div style={{ maxWidth: 560 }}>
          <p
            style={{
              fontSize: 11,
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              color: "rgba(255, 215, 0, 0.7)",
              margin: "0 0 1.5rem",
              fontWeight: 600,
            }}
          >
            Something broke
          </p>
          <h1
            style={{
              fontSize: "clamp(2rem, 1rem + 3vw, 3rem)",
              lineHeight: 1.05,
              letterSpacing: "-0.03em",
              fontWeight: 800,
              margin: "0 0 1rem",
            }}
          >
            We&apos;ll be right back.
          </h1>
          <p
            style={{
              fontSize: 15,
              color: "rgba(255, 253, 231, 0.6)",
              margin: "0 0 2rem",
              lineHeight: 1.5,
            }}
          >
            Something critical failed on our end. Try reloading, or come back in
            a minute.
          </p>
          <button
            onClick={reset}
            style={{
              background: "linear-gradient(135deg, #FFD700, #CC8A00)",
              color: "#0a0f1a",
              border: "none",
              borderRadius: "0.75rem",
              padding: "0.875rem 1.75rem",
              fontSize: 14,
              fontWeight: 700,
              cursor: "pointer",
              letterSpacing: "-0.01em",
            }}
          >
            Try again
          </button>
          {error.digest && (
            <p
              style={{
                fontSize: 11,
                color: "rgba(255, 253, 231, 0.3)",
                fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
                marginTop: "2.5rem",
              }}
            >
              Error ref: {error.digest}
            </p>
          )}
        </div>
      </body>
    </html>
  );
}
